import { Controller } from "@hotwired/stimulus"

// Optimistic "Pop" (champagne) reaction toggle for activity items.
// Targets: bottle (the <svg>), count (the count <span>), burst (overlay span)
// Values: activityId, popped, count, csrf
export default class extends Controller {
  static targets = ["bottle", "count", "burst"]
  static values = { activityId: Number, popped: Boolean, count: Number }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()
    const wasPopped = this.poppedValue
    this.setPopped(!wasPopped)
    if (!wasPopped) this.spray()

    const method = wasPopped ? "DELETE" : "POST"
    const url = wasPopped ? `/reactions/${this.activityIdValue}` : "/reactions"
    const body = wasPopped
      ? null
      : new URLSearchParams({ activity_id: this.activityIdValue })

    fetch(url, {
      method,
      headers: { "X-CSRF-Token": this.csrfToken, Accept: "application/json" },
      body,
    })
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then((data) => {
        this.countValue = data.count
        this.render()
      })
      .catch(() => {
        this.setPopped(wasPopped)
      }) // revert on failure
  }

  setPopped(popped) {
    this.poppedValue = popped
    this.countValue = Math.max(0, this.countValue + (popped ? 1 : -1))
    this.render()
  }

  render() {
    const el = this.element
    el.classList.toggle("text-neon-yellow-orange", this.poppedValue)
    el.classList.toggle("ring-neon-yellow-orange/40", this.poppedValue)
    el.classList.toggle("text-app-text-muted", !this.poppedValue)
    el.classList.toggle("ring-app-border-subtle", !this.poppedValue)
    el.style.background = this.poppedValue ? "#FFCC3320" : ""
    // fill the bottle paths
    this.bottleTarget.querySelectorAll("[data-fillable]").forEach((p) => {
      p.setAttribute("fill", this.poppedValue ? "currentColor" : "none")
    })
    if (this.hasCountTarget) {
      this.countTarget.textContent = this.countValue > 0 ? this.countValue : ""
    }
  }

  spray() {
    this.bottleTarget.classList.remove("pop-recoil")
    void this.bottleTarget.offsetWidth // reflow to restart animation
    this.bottleTarget.classList.add("pop-recoil")
    if (!this.hasBurstTarget) return
    this.burstTarget.innerHTML = ""
    for (let i = 0; i < 8; i++) {
      const b = document.createElement("span")
      const bx = Math.round(Math.random() * 16 + 5)
      const by = -Math.round(Math.random() * 18 + 9)
      const size = (Math.random() * 2.5 + 2.5).toFixed(1)
      b.className = "pop-bubble absolute rounded-full"
      b.style.cssText = `width:${size}px;height:${size}px;background:#FFCC33;margin-left:-1px;margin-top:-1px;--bx:${bx}px;--by:${by}px;animation-delay:${Math.round(Math.random() * 130)}ms`
      this.burstTarget.appendChild(b)
    }
    setTimeout(() => {
      if (this.hasBurstTarget) this.burstTarget.innerHTML = ""
    }, 900)
  }

  get csrfToken() {
    return document.querySelector('meta[name="csrf-token"]')?.content
  }
}
